import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import sliderDefaultWithTooltip from 'src/examples/Slider/defaultWithTooltip';
import sliderWithFixedValues from 'src/examples/Slider/fixedValues';
import sliderRange from 'src/examples/Slider/range';
import sliderVariants from 'src/examples/Slider/variant';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  sliderDefaultWithTooltip,
  sliderWithFixedValues,
  sliderRange,
  sliderVariants,
  React
};